import { render, staticRenderFns } from "./StaffAirCompanyInstruction.vue?vue&type=template&id=253c617a&scoped=true&"
import script from "./StaffAirCompanyInstruction.vue?vue&type=script&lang=js&"
export * from "./StaffAirCompanyInstruction.vue?vue&type=script&lang=js&"
import style0 from "./StaffAirCompanyInstruction.vue?vue&type=style&index=0&id=253c617a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253c617a",
  null
  
)

export default component.exports